import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { formatNumber, truncateText } from "../../../../../../utility/helper";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { Pagination } from "../../../../../../components/Stepper/fields/inputField";
import { useSelector } from "react-redux";

const MovementComponent = ({
  viewTransaction,
  handleOptionSelect,
  confirmDelete,
  setLimit,
  limit,
  setPage,
  page,
  selectedAsset,
}) => {
  const [loading, setLoading] = useState(false);
  const { currency } = useSelector((state) => state.user);

  const onPageChange = (e) => {
    setPage(e.page);
    setLimit(e.rows);
  };

  const reasonTemplate = (rowData) => {
    return rowData.reason ? truncateText(rowData.reason, 19) : "-";
  };

  const currencyTemplate = () => {
    return currency ? currency : "-";
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none mr-2 ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-primary dark:text-primary"
          }`}
        >
          <FaEdit
            onClick={() => {
              if (!rowData?.is_default) {
                handleOptionSelect(rowData.type, "Update", rowData);
              }
            }}
          />
        </button>
        <button
          disabled={rowData?.is_initial}
          className={`focus:outline-none ${
            rowData?.is_initial
              ? "dark:text-gray-400 text-info cursor-not-allowed"
              : "text-darkWaring"
          }`}
        >
          <FaRegTrashAlt
            onClick={() => {
              if (!rowData?.is_default) {
                confirmDelete(rowData);
              }
            }}
          />
        </button>
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    return moment(rowData.date).format("DD-MM-YYYY");
  };

  const cashTemplate = (rowData) => {
    const cashValue = rowData.amount ? rowData.amount : 0;
    const type = rowData.type?.toUpperCase();
    const formattedValue = formatNumber(cashValue);

    return type === "SELL" || type === "EXPENSE" ? (
      <>{cashValue !== 0 ? `-${formattedValue}` : formattedValue}</>
    ) : (
      <>{formattedValue}</>
    );
  };

  return (
    <div className="border border-lightPrimary/40 dark:border-info/40 min-h-[53vh] pb-3 dark:bg-card-custom-radial">
      <h2 className="text-2xl text-lightPrimary dark:text-primary-gradient font-semibold p-4">
        {selectedAsset?.name
          ? `Company - ${selectedAsset?.name}`
          : "No Asset found"}
      </h2>
      <DataTable
        value={viewTransaction?.transactions}
        className="transaction mt-3"
        sortMode="multiple"
        // paginator
        rows={limit}
        totalRecords={viewTransaction?.total}
        first={page * limit}
        onPage={onPageChange}
        loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column
          field="date"
          header="Date"
          body={dateTemplate}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="type"
          header="Transaction Type"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="remark"
          header="Reason"
          body={reasonTemplate}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        {/* <Column
          field="currency"
          header="Currency"
          body={currencyTemplate}
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        /> */}
        <Column
          field="amount"
          header="Transaction Amount"
          body={cashTemplate}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
        <Column
          field="Action"
          header="Action"
          body={actionBodyTemplate}
          align="right"
          headerClassName="text-xl font-normal !text-lightPrimary dark:!text-primary-gradient"
          bodyClassName="text-base text-lightPrimary dark:text-grey font-light"
        />
      </DataTable>
      <Pagination
        page={page}
        limit={limit}
        total={viewTransaction?.total || 0}
        onPageChange={(newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default MovementComponent;
